import script from "./SharedTicketComments.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedTicketComments.vue?vue&type=script&setup=true&lang=js"

import "./SharedTicketComments.vue?vue&type=style&index=0&id=0f06d7c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f06d7c8"]])

export default __exports__